module.exports = __webpack_public_path__ + "static/media/120.872ef5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/120.jpg
// module id = 930
// module chunks = 0